//Serviços
import { AxiosCadastro } from "../../service/serviceBasic";
import {
  converterListActionForListReduceDropdownRendaMensal,
  converterListActionForListReduceDropdownPatrimonio
} from "../../helper/converter";

//Tipos
import {
  LOADING_LIST_RENDA_MENSAL,
  SET_LIST_RENDA_MENSAL,
  LOADING_LIST_PATRIMONIO,
  SET_LIST_PATRIMONIO
} from './types';

const loadingListRendaMensalAction = (flag) => ({
  type: LOADING_LIST_RENDA_MENSAL,
  payload: flag,
});
const setListRendaMensalAction = (list) => ({
  type: SET_LIST_RENDA_MENSAL,
  payload: list,
});
const loadingListPatrimonioAction = (flag) => ({
  type: LOADING_LIST_PATRIMONIO,
  payload: flag,
});
const setListPatrimonioAction = (list) => ({
  type: SET_LIST_PATRIMONIO,
  payload: list,
});

export const getListRendaMensalAction = () => (dispatch) => {
  dispatch(loadingListRendaMensalAction(true));
  return AxiosCadastro.post("v1/basico/rendamensal/list", {})
    .then((response) => {
      let listResponse = converterListActionForListReduceDropdownRendaMensal(
        response.data
      );

      dispatch(setListRendaMensalAction(listResponse));
    })
    .finally(() => {
      dispatch(loadingListRendaMensalAction(false));
    });
};
export const getListPatrimonioAction = () => (dispatch) => {
  dispatch(loadingListPatrimonioAction(true));
  return AxiosCadastro.post("v1/basico/patrimonio/list", {})
    .then((response) => {
      let listResponse = converterListActionForListReduceDropdownPatrimonio(
        response.data
      );

      dispatch(setListPatrimonioAction(listResponse));
    })
    .finally(() => {
      dispatch(loadingListPatrimonioAction(false));
    });
};
